import { Text } from "evergreen-ui";
export const SubTitle = () => {
  return (
    <Text color="inherit" fontWeight="bold">
      App development for web, mobile, and desktop.
    </Text>
  );
};
